var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-stack"},[_c('div',{staticClass:"modal-stack__modals"},[_vm._l((_vm.$store.state.ui.modals),function(modal){return _c('DynamicModal',{key:modal.Id,attrs:{"modal":modal}})}),_c('PredefinedModals')],2)])}
var staticRenderFns = []

export { render, staticRenderFns }